import Accordion from './Accordion';

function stringToReactList(string: string) {
  // Split the string into paragraphs
  const regex = /<p[^>]*>([^<]*)<\/p>/g;
  const matches = string?.matchAll(regex);
  const paragraphs = Array.from(matches ?? [], (match) => match[0]);

  // Map each paragraph to a React element
  const reactElements = paragraphs.map((paragraph, index) => {
    const propsRegex = /<p([^>]*)>/;
    const propsMatch = paragraph.match(propsRegex);
    const dirProp =
      propsMatch && propsMatch[1].includes('dir=') ? { dir: 'rtl', className: 'text-right font-naksh' } : {};

    return (
      <li key={index}>
        <p {...dirProp}>{paragraph.replace(propsRegex, '').replace('</p>', '')}</p>
      </li>
    );
  });

  // Wrap the React elements in an unordered list
  return <ul>{reactElements}</ul>;
}

export default function CommentSection({ comments, showComment }: { comments: any; showComment: boolean }) {
  return (
    <Accordion open={showComment}>
      <div className="overflow-none divide-y border-t-2">
        {comments?.map((comment: any) => {
          return (
            <div key={comment.id}>
              <div className="w-full text-center mt-2 font-semibold">{comment.authorName}</div>
              <div className="m-6">
                {String(comment.comments).includes('<p>')
                  ? stringToReactList(String(comment.comments))
                  : comment.comments}
              </div>
            </div>
          );
        })}
      </div>
    </Accordion>
  );
}
